import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

// The comment/notes editor (MGDWD-148). Separate from QuillInput, which is
// bound to Formik and carries a plan-description toolbar (headings, the
// check-list marker from MGDWD-207). Comment forms are plain controlled
// inputs, so this one is controlled by value/onChange.

// Deliberately small. Chris and members write prose and paste links; anything
// more turns a comment box into a layout tool, and every format allowed here
// has to survive sanitising on render and again in the email.
const CommentModules = {
	toolbar: [
		["bold", "italic", "underline"],
		[{ list: "bullet" }, { list: "ordered" }],
		["link"],
		["clean"],
	],
};

const CommentFormats = ["bold", "italic", "underline", "list", "link"];

function CommentEditor({ value, onChange, placeholder, readOnly }) {
	return (
		<div className="rich-text-input w-100">
			<ReactQuill
				theme="snow"
				modules={CommentModules}
				formats={CommentFormats}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				readOnly={readOnly}
			/>
		</div>
	);
}

export default CommentEditor;
